import React, {useContext, useState, useEffect} from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import {TeacherContext} from 'teacher/context'
import BackButton from 'components/back-button'
import moment from 'moment'

const useStyles = makeStyles(studentGradesInfoBarStyles)

export default function StudentGradesInfoBar () {
  const classes = useStyles()

  const {translate, rollbookContextPeriods, rollbookContextStudentGradesNavigation, link, linkQuery} = useContext(TeacherContext)
  const defaulBackLink = link({page: 'gradebook'}, '/:languageId/:role/:page')
  const [backLink, setBackLink] = useState(defaulBackLink)
  const {loaded, items} = rollbookContextPeriods
  const firstAndLast = loaded && items.length > 0
    ? [items[0], items[items.length - 1]]
    : [{start: ''}, {finish: ''}]
  const [{start}, {finish}] = firstAndLast
  const label = `${translate('rollbook')} ${moment(start).year()} - ${moment(finish).year()}`

  function updateBackLink() {
    if (rollbookContextStudentGradesNavigation) {
      const {origin = defaulBackLink, query} = rollbookContextStudentGradesNavigation
      setBackLink(linkQuery(origin, query, true))
    }
  }

  useEffect(updateBackLink, [])
  useEffect(updateBackLink,[rollbookContextStudentGradesNavigation])

  return (
    <Box className={classes.root}>
      <BackButton link={backLink} />
      <Box className={`${classes.middle} ${classes.label}`}>
        {label}
      </Box>
      <Box style={{flexGrow: 1}} />
    </Box>
  )
}

function studentGradesInfoBarStyles(theme) {
  return {
    root: {
      display: 'flex',
      borderBottom: 'solid 1px #dbe3e6',
      minHeight: '60px',
    },
    middle: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    label: {
      marginLeft: 10,
      color: '#636b80',
      fontWeight: 'bold',
      [theme.breakpoints.down('xs')]: {
        marginLeft: 5,
      },
      fontSize: '12pt'
    },
  }
}
